<template>
	<v-layout row wrap>
  {{lead}}
	</v-layout>
</template>

<script>
import {firebase, db, auth} from '@/fb';
import dashboardParalex from '../components/dashboardParalex';
import MiniStatistic from '@/components/MiniStatistic';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
import Papa from 'papaparse'
import { setTimeout } from 'timers';
export default {
    data() {
        return {
					loading:false,
					id:null,
					lead:null,
        }
		},
		methods:{
			loadLead(){
				this.id = this.$route.params.id
				db.ref(`leads/${this.id}`)
				.once('value')
				.then(snap=>{
					this.lead = snap.val()
				})
			},
			
		},
		watch: {
			
		},
		created() {
			this.loadLead()
		}
}
</script>

<style>

</style>
